export default function About() {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block px-4 py-2 bg-orange-500 text-white rounded-full text-sm font-semibold mb-6">
              ABOUT US
            </div>
            
            <div className="mb-8">
              <img
                src="https://public.readdy.ai/ai/img_res/01562d07d94b5ebb34c2b86df8df9236.jpg"
                alt="Sorto's Premier Roofing Team"
                className="w-full h-80 object-cover object-top rounded-2xl shadow-xl"
              />
            </div>
          </div>

          {/* Right Content */}
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Sorto's Premier Roofing<br />
              <span className="text-orange-500">Your Trusted Local</span><br />
              Roofing Experts
            </h2>
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              At Sorto's Premier Roofing And Const LLC, we're committed to providing exceptional roofing services with guaranteed quality and fast, professional service. Our experienced team specializes in both residential and commercial roofing projects.
            </p>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              From free inspections to complete roof replacements, we handle every project with the same dedication to excellence. We also offer comprehensive exterior services including gutters, soffit, fascia, siding, and windows installation.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100">
                <div className="text-4xl font-bold text-orange-500 mb-2">100%</div>
                <div className="text-sm text-gray-600 font-semibold">Satisfaction Guaranteed</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100">
                <div className="text-4xl font-bold text-orange-500 mb-2">24/7</div>
                <div className="text-sm text-gray-600 font-semibold">Emergency Services</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100">
                <div className="text-4xl font-bold text-orange-500 mb-2">Free</div>
                <div className="text-sm text-gray-600 font-semibold">Roof Inspections</div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100">
                <div className="text-4xl font-bold text-orange-500 mb-2">Full</div>
                <div className="text-sm text-gray-600 font-semibold">Warranty Coverage</div>
              </div>
            </div>

            {/* Why Choose Us */}
            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-star-fill text-xl text-orange-500"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-1">Quality Craftsmanship</h3>
                  <p className="text-sm text-gray-600">Expert installation using premium materials and proven techniques</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-customer-service-2-fill text-xl text-orange-500"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-1">Exceptional Service</h3>
                  <p className="text-sm text-gray-600">Responsive communication and professional service from start to finish</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-price-tag-3-fill text-xl text-orange-500"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-1">Fair Pricing</h3>
                  <p className="text-sm text-gray-600">Competitive rates with transparent quotes and no hidden fees</p>
                </div>
              </div>
            </div>

            <button
              onClick={() => {
                const element = document.getElementById('contact');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-4 bg-gray-900 hover:bg-orange-500 text-white font-bold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              Learn More About Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
